import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pdmpDetails',
  templateUrl: './pdmpDetails.component.html',
  styleUrls: ['./pdmpDetails.component.css']
})
export class PdmpDetailsComponent  {
  @Input() pdmpData: any;

  constructor() {

  };

  }


